import { LinkedItemTypeEnum } from '../../linked-items/linked-item-type-enum';

import { EntityType } from './segment-track-event.enum';

/**
 * Linked-item domain type → schema `entityType`.
 *
 * The linked-items feature carries its own type vocabulary (`LinkedItemTypeEnum`) and the
 * LINKED_ITEM_* events emitted it verbatim as `entityType` / `parentEntity`. Six of its eleven
 * values are not `EntityType` members, so a linked learning topic shipped
 * `entityType: 'learningTopic'` while `kst_topic_updated` shipped `'topic'` for the same kind of
 * entity — the two could not be joined in the warehouse. This map normalizes to the schema
 * vocabulary. Typing it `Record<LinkedItemTypeEnum, EntityType>` is the guard: a new enum member
 * fails to compile until it is mapped, and it can only be mapped to a schema value.
 *
 * Two collapses are deliberate, and each matches how the owning feature already reports itself:
 * - `learningSubject` and `learningTopic` both → `topic`. `kst_topic_duplicated` already covers
 *   both KST levels under `topic`.
 * - `cascadingMessage` → `headline`. The `cascaded_message_*` events all report `headline`.
 *
 * The granular linked-items value is intentionally not also emitted as a separate param; nothing
 * consumes that split today, and the contract says not to add enrichment by default.
 */
export const LINKED_ITEM_ENTITY_TYPE: Record<LinkedItemTypeEnum, EntityType> = {
  [LinkedItemTypeEnum.todo]: 'todo',
  [LinkedItemTypeEnum.issue]: 'issue',
  [LinkedItemTypeEnum.headline]: 'headline',
  [LinkedItemTypeEnum.rock]: 'rock',
  [LinkedItemTypeEnum.cascadingMessage]: 'headline',
  [LinkedItemTypeEnum.learningTask]: 'task',
  [LinkedItemTypeEnum.learningTopic]: 'topic',
  [LinkedItemTypeEnum.learningSubject]: 'topic',
  [LinkedItemTypeEnum.milestone]: 'milestone',
  [LinkedItemTypeEnum.goal]: 'goal',
  [LinkedItemTypeEnum.peopleAnalyzerReview]: 'review',
};
